import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';
import { logger } from 'src/utils/serverLogger';
const { publicRuntimeConfig } = getConfig() as NextConfig;
import type { MononothPartnerContentResponse } from './types/MononothPartnerContentResponse';
import type { MononothPartnerRedirectResponse } from './types/MononothPartnerRedirectResponse';

export const TIMEOUT = 750;

const getMononothApiEndpoint = () => publicRuntimeConfig.endpoints.mononothPublic;

export interface FetchPartnerDataArgs {
  shortcode: string;
}

export const fetchPartnerData = async ({
  shortcode,
}: FetchPartnerDataArgs): Promise<
  MononothPartnerContentResponse | MononothPartnerRedirectResponse | null
> => {
  const path = '/api/browse/v1/partner_query';
  const query = `shortcode=${shortcode}`;
  const url = new URL(`${getMononothApiEndpoint()}${path}?${query}`);
  const requestUrl = url.toString();

  const apiResponse = (await fetchJSONWithTimeout(requestUrl, {
    timeout: TIMEOUT,
  })) as Response;
  const { status } = apiResponse;

  switch (status) {
    case 200: {
      const data = await apiResponse.json();

      if (data.redirect_url) {
        return data as MononothPartnerRedirectResponse;
      }

      return data as MononothPartnerContentResponse;
    }
    case 404: {
      logger.warn('partner data not found in Mononoth', { requestUrl });

      return null;
    }
    default: {
      logger.error('error fetching partner data from Mononoth', {
        requestUrl,
        status,
      });

      return null;
    }
  }
};
